function lastLowest(best, value) {
  return value <= best;
}

exports.lastLowest = lastLowest;